import React, { KeyboardEventHandler, useRef, useState } from "react";
import { FieldProps, useFormikContext } from "formik";
import eyeImg from "assets/eye-slash.svg";
import eyeHideImg from "assets/eye.svg";
import arrow from "assets/recentlyAdded/qb_arrow_Vector.svg";
import arrowUp from "assets/recentlyAdded/qb_arrow_up.svg";
import "../Input/Input.scss";

type InputProps = {
  label: string;
  type: any;
  placeholder?: string;
  toggleVisibility?: () => void;
  secure?: boolean;
  required?: boolean;
  onChange?: any;
  onBlur?: any;
  style?: any;
  mandatory?: string;
  disabled?: boolean;
  defaultValue?: string;
  name?: string;
  value?: string | number;
  step?: string;
};

const InputField: React.FC<InputProps & FieldProps> = ({
  field,
  form: { touched,errors },
  // meta,
  ...props
}) => {
  const [visible, setVisible] = useState(false);
  const { label, type, secure, required, mandatory } = props;

  const toggleVisibility = () => {
    setVisible(!visible);
  };

  const { setFieldValue, setFieldTouched } = useFormikContext<any>();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    field.onChange(event);
    props.onChange?.(event);
  };

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    field.onBlur(event);
    props.onBlur?.(event);
  };

  const increase = () => {
    let newValue = 0;
    const step = Number(props.step) || 1;
    
    if (!field.value || Number.isNaN(field.value)) {
      newValue = step;
    } else {
      newValue = Number(field.value) + step;
    }
    setFieldTouched(field.name, true);
    setFieldValue(field.name, newValue, true);
  };
  const decrease = () => {
    let newValue;
    const step = Number(props.step) || 1;
    if (Number(field.value) - step > 0) {
      newValue = Number(field.value) - step;
    } else {
      newValue = 0;
    }
    setFieldTouched(field.name, true);
    setFieldValue(field.name, newValue, true);
  };

  const setInputType = () => {
    let inputType = type;
    if (secure) {
      if (visible) {
        inputType = "text";
      }
    }
    return inputType;
  };
  return (
    <div className="form-group">
      <label className="capitalize" style={{textOverflow: 'ellipsis'}}>
        {label}
        {mandatory && <span className="danger mandatory">{mandatory}</span>}
      </label>
      <div className="input-wrapper">
        {secure && (
          <img
            onClick={toggleVisibility}
            className="vector-img"
            src={visible ? eyeHideImg : eyeImg}
            alt="vector-img"
          />
        )}
        {type === "number" && (
          <div className="vector-img">
            <img src={arrowUp} alt="arrow" onClick={increase} />
            <img src={arrow} alt="arrow" onClick={decrease} />
          </div>
        )}
        <input
          {...field}
          {...props}
          value={field.value}
          type={setInputType()}
          required={required}
          autoComplete="off"
          security="restricted"
          onChange={handleChange}
          onBlur={handleBlur}
          className={
            touched[field.name] && errors[field.name] ? "error-state" : ""
          }
        />
        {/* {meta?.touched && meta?.error && (
          <div className="error">{meta?.error}</div>
        )} */}
      </div>
    </div>
  );
};

export default InputField;
